"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRuleEngineFromAPI = exports.mapRulesDataStoreFromAPI = exports.mapDeviceFromAPI = exports.mapPresentationsFromAPI = exports.mapPlaylistsFromAPI = void 0;
var RuleEngine_1 = require("./RuleEngine");
var RETypes = __importStar(require("./Types"));
var mapObjectValues = function (object, fn) {
    var mappedObject = {};
    Object.entries(object).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        mappedObject[key] = fn(value);
    });
    return mappedObject;
};
// Converts an array of API tags to a key-value map.
var mapTagsFromAPI = function (tags) {
    var tagsByKey = {};
    for (var _i = 0, tags_1 = tags; _i < tags_1.length; _i++) {
        var tag = tags_1[_i];
        tagsByKey[tag.key] = tag.value;
    }
    return tagsByKey;
};
function mapPlaylistsFromAPI(playlists) {
    return mapObjectValues(playlists, function (pl) {
        var rule = null;
        var override = false;
        var scheduleRule = undefined;
        if (pl.startDatetime && pl.endDatetime && pl.tzid) {
            scheduleRule = {
                type: 'schedule',
                startDatetime: pl.startDatetime,
                endDatetime: pl.endDatetime,
                tzid: pl.tzid,
                recurrenceRule: pl.recurrenceRule || undefined
            };
            // Schedule type should always be either 'join' or 'override' but just in case
            // we will default to override if type is not set to maintain existing behaviour
            // before we added the 'join' type.
            override = pl.scheduleType !== 'join';
        }
        else if (pl.scheduleType === 'override') {
            // Setting override flag for a non scheduled playlists (i.e. configured with Worker)
            override = true;
        }
        rule = pl.rule;
        return {
            id: pl.id,
            name: pl.name,
            mode: RETypes.PlaylistMode.Sequential,
            items: pl.r.playlistItems,
            isDeleted: !!pl.r.resource.deletedAt,
            hasPlaylists: false,
            isRuleOnItems: pl.isRuleOnItems,
            tags: mapTagsFromAPI(pl.r.resource.r.tags),
            rule: rule,
            scheduleRule: scheduleRule,
            override: override
        };
    });
}
exports.mapPlaylistsFromAPI = mapPlaylistsFromAPI;
function mapPresentationsFromAPI(presentations, applicationVersions, applications) {
    return mapObjectValues(presentations, function (p) {
        var applicationVersion = applicationVersions[p.applicationDeploymentId];
        if (!applicationVersion) {
            throw new Error("Error creating presentation state for rule engine, missing application version for presentation '".concat(p.id, "'"));
        }
        var application = applications[applicationVersion.applicationId];
        if (!application) {
            throw new Error("Error creating presentation state for rule engine, missing application for presentation '".concat(p.id, "'"));
        }
        return {
            id: p.id,
            applicationName: application.name,
            isDeleted: !!p.r.resource.deletedAt,
            hasPlaylists: p.r.presentationsPlaylists.length > 0,
            tags: mapTagsFromAPI(p.r.resource.r.tags)
        };
    });
}
exports.mapPresentationsFromAPI = mapPresentationsFromAPI;
function mapDeviceFromAPI(device) {
    return {
        tags: device ? mapTagsFromAPI(device.r.resource.r.tags) : {},
        timezone: device ? device.timezone : null
    };
}
exports.mapDeviceFromAPI = mapDeviceFromAPI;
function mapRulesDataStoreFromAPI(device, workers) {
    return {
        device: device ? mapDeviceFromAPI(device) : {},
        workers: workers ? workers : {}
    };
}
exports.mapRulesDataStoreFromAPI = mapRulesDataStoreFromAPI;
function createRuleEngineFromAPI(playlistId, playlists, presentations, applicationVersions, applications, device, globalRule, isMultitimezoneEnabled, workers) {
    var state = new RuleEngine_1.State(mapPlaylistsFromAPI(playlists), mapPresentationsFromAPI(presentations, applicationVersions, applications), mapRulesDataStoreFromAPI(device, workers), isMultitimezoneEnabled);
    return new RuleEngine_1.RuleEngine(playlistId, state, globalRule);
}
exports.createRuleEngineFromAPI = createRuleEngineFromAPI;
